<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  created(){
    console.log("app created")
    // this.fetch();
  },
  methods:{
   async fetch(){
     const res = await this.$fly.get();
     console.log(res);
     
   }
  }
}
</script>

<style lang='scss'>
html, body{
  padding: 0;
  margin: 0;
  background-color: #f4f4f4;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
a{
  text-decoration:none;
}

</style>
